import styled from '@emotion/styled'
import { css } from '@emotion/react'

const wrapperStyles = ({ theme }) => css`
  label: wrapper-coupon-availability;

  padding-top: ${theme.spacings.mega};
`

export const Wrapper = styled('div')(wrapperStyles)
